import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, unref as _unref, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/banner2/icon-login.png'
import _imports_1 from '../../assets/img/step/step-top.svg'
import _imports_2 from '../../assets/img/step/step-ico.svg'
import _imports_3 from '../../assets/img/tradingSystem/new-tag.png'
import _imports_4 from '../../assets/img/bidEvaluationTools/time.png'
import _imports_5 from '../../assets/img/tradingSystem/npapp.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-abf2ae12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<header class=\"banner\" data-v-abf2ae12><div class=\"banner-content\" data-v-abf2ae12><div class=\"banner-text\" data-v-abf2ae12><p class=\"banner-title\" data-v-abf2ae12>互联场地专家评标登录工作台</p><p class=\"banner-desc\" data-v-abf2ae12>助力建设全国统一大市场，优化市场营商环境</p></div><img src=\"" + _imports_0 + "\" alt=\"\" class=\"banner-img\" data-v-abf2ae12></div></header>", 1)
const _hoisted_3 = { class: "box" }
const _hoisted_4 = { class: "stepbox" }
const _hoisted_5 = { class: "stepitembg" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "overtop" }, null, -1))
const _hoisted_7 = { class: "stepitem" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-top" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "",
    style: {"width":"133px","height":"70px"}
  })
], -1))
const _hoisted_9 = { class: "stepindex" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "stepico" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: "",
    style: {"width":"32px","height":"35px"}
  })
], -1))
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  style: {"display":"flex","margin-top":"44px","justify-content":"space-evenly","padding":"0 10px"}
}
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex","margin-top":"34px","justify-content":"space-evenly","padding":"0 10px"}
}
const _hoisted_15 = { class: "select-box" }
const _hoisted_16 = { class: "select-top" }
const _hoisted_17 = { class: "search" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "platformtype-title" }
const _hoisted_20 = { class: "content-box" }
const _hoisted_21 = ["onMouseenter", "onMouseleave"]
const _hoisted_22 = {
  key: 0,
  class: "province-item"
}
const _hoisted_23 = ["src"]
const _hoisted_24 = {
  key: 0,
  src: _imports_3,
  alt: "",
  class: "new-tag"
}
const _hoisted_25 = {
  key: 1,
  class: "hover-content"
}
const _hoisted_26 = { class: "hover-logo" }
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "hover-text" }
const _hoisted_29 = { class: "time" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "",
  style: {"width":"14px","height":"14px"}
}, null, -1))
const _hoisted_31 = {
  class: "info-text3",
  style: {"margin-left":"3px"}
}
const _hoisted_32 = { class: "province-item" }
const _hoisted_33 = {
  class: "platformtype-title",
  style: {"margin-top":"16px"}
}
const _hoisted_34 = { class: "municipality-title" }
const _hoisted_35 = { class: "municipality-name" }
const _hoisted_36 = { class: "municipality-total" }
const _hoisted_37 = { class: "municipality-content" }
const _hoisted_38 = { class: "municipality-inner" }
const _hoisted_39 = { class: "province-item" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "",
  class: "noapp",
  style: {"border":"none"}
}, null, -1))
const _hoisted_41 = [
  _hoisted_40
]

import { nextTick, onMounted, ref } from 'vue'
import mytitle from '../../components/title.vue'
import contactUs from '../../components/contactUs.vue'
import { reginList } from '../../const/index'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'expertLogin',
  setup(__props) {

const route = useRoute()

onMounted(async () => {
  await nextTick(); // 等待 DOM 更新
  if (route.query.bottom) {
    // 滚动到距离页面顶部800px的位置  
    window.scrollTo({
      top: 900,
      behavior: 'smooth' // 可选，用于平滑滚动  
    });
  } else {
    window.scrollTo(0, 0);
  }
})

const stepInfo = ref([
  {
    title: '阅读接入指南',
    description: '预览、下载《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》',
    url: 'T04远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南_20250605_1600.pdf',
  },
  {
    title: '远程异地评标<br>目录服务组件集成对接',
    description: '运营机构联系中国招标投标公共服务平台运维实施人员集成对接远程异地评标共享目录服务组件',
    url: 'T04远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南_20250605_1600.pdf',
  },
  {
    title: '与跨省远程异地目录服务<br/>组件共同联调测试',
    description: '与跨省远程异地目录服务组件共同联调测试相关接口',
    contactUs: true,
    showContact: false,
  },
  {
    title: '公开测试承诺',
    description: '与跨省远程异地目录服务组件共同联调测试通过后，通过远程异地评标和评标专家库共享目交易中心场所自助管理终端，上传并公开测试承诺书和自主测试报告，自助加入场地专家评标登录工作台互联目录',
  }
])

const preview = (url: string) => {
  window._czc.push(['_trackEvent', '场地专家评标', '预览', '场地专家评标登录工作台接入指南预览'])
  window.open(url, '_blank')
}

const download = (url: string) => {
  window._czc.push(['_trackEvent', '场地专家评标', '下载', '场地专家评标登录工作台接入指南预览'])
  const link = document.createElement('a')
  link.href = url
  link.download = url
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const platformParms = ref({
  platformName: '',
})

//省级
let platformList = ref([
  {
    createTime: "2024-12-19 09:15:44",
    provinceName: "湖北省",
    provinceCode: "42",
    isNew: true,
    sort: 5,
    platformList: [],
    isHovered: false,
    firstPlatform: {
      id: "1869552157550780418",
      platformCode: "",
      platformName: "湖北省电子招投标交易平台",
      platformUrl: "",
      platformOrgName: "湖北省公共资源交易中心",
      platformOrgCode: "12420000767423658J",
      platformContactName: "李炜",
      platformContactPhone: "13886032676",
      platformLogo: require("@/assets/img/image.png"),
      createUserName: "",
      updateUserName: "",
      createTime: "2025/3/30 18:30:56",
      platformRegionName: "湖北省",
    },
  },
])

const noreginList = ref<any[]>([])
noreginList.value = reginList.filter(
  (item) => !platformList.value.some((item2) => item2.provinceCode == item.key)
);

const cityList = ref<any[]>([])
const total = ref(0)
cityList.value = reginList.map((item) => {
  return {
    ...item,
    platformList: []
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createVNode(mytitle, {
        title: "对接实施具体步骤",
        style: {"margin-top":"64px"}
      }),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepInfo.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (item.title)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_6,
                  _withDirectives(_createVNode(contactUs, null, null, 512), [
                    [_vShow, item.showContact]
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, _toDisplayString(index + 1), 1),
                    _hoisted_10,
                    _createElementVNode("div", {
                      class: "stepTitle",
                      innerHTML: item.title
                    }, null, 8, _hoisted_11),
                    _createElementVNode("div", {
                      class: "stepText",
                      innerHTML: item.description
                    }, null, 8, _hoisted_12),
                    (item.url)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _createVNode(_component_el_button, {
                            class: "btn2",
                            onClick: ($event: any) => (preview(item.url))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("预览")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            class: "btn1",
                            onClick: ($event: any) => (download(item.url))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("下载")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (item.contactUs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_el_button, {
                            class: "btn2",
                            style: {"width":"356px"},
                            onMouseover: ($event: any) => (item.showContact = true),
                            onMouseleave: ($event: any) => (item.showContact = false)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("联系我们")
                            ]),
                            _: 2
                          }, 1032, ["onMouseover", "onMouseleave"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        }), 256))
      ])
    ]),
    _createElementVNode("section", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createVNode(mytitle, {
          title: "互联场地专家评标登录工作台目录",
          color: "white",
          style: {"margin-top":"64px"}
        }),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_el_input, {
            modelValue: platformParms.value.platformName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((platformParms.value.platformName) = $event)),
            placeholder: "请输入场地专家评标登录工作台名称搜索",
            class: "paperview-input-text"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_button, {
            type: "primary",
            class: "searchbtn"
          }, {
            default: _withCtx(() => [
              _createTextVNode("搜索")
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, "省级（" + _toDisplayString(_unref(platformList).length) + "）", 1),
        _createElementVNode("div", _hoisted_20, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(platformList), (item) => {
            return (_openBlock(), _createElementBlock("div", {
              onMouseenter: ($event: any) => (item.isHovered = true),
              onMouseleave: ($event: any) => (item.isHovered = false)
            }, [
              (!item.isHovered)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("img", {
                      src: item.firstPlatform.platformLogo,
                      alt: "",
                      style: {"width":"130px","height":"130px"}
                    }, null, 8, _hoisted_23),
                    (item.isNew)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (item.isHovered)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("img", {
                        src: item.firstPlatform.platformLogo,
                        alt: ""
                      }, null, 8, _hoisted_27)
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("p", null, _toDisplayString(item.firstPlatform.platformContactName), 1),
                      _createElementVNode("p", null, _toDisplayString(item.firstPlatform.platformContactPhone), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("span", _hoisted_31, _toDisplayString(item.createTime), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 40, _hoisted_21))
          }), 256)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noreginList.value, (n) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(n.title), 1))
          }), 256))
        ]),
        _createElementVNode("div", _hoisted_33, "地级市（" + _toDisplayString(total.value) + "）", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cityList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_36, " 共加入 " + _toDisplayString(item.platformList.length) + " 家", 1)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (n) => {
                  return _createElementVNode("div", _hoisted_39, _hoisted_41)
                }), 64))
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})